import { QRCodeSVG } from "qrcode.react";
import { IMAGES, LINKS, CONTENT } from "../const/config";
import { useStoreLinks } from "../hooks/useStoreLinks";

import {
  FaTiktok,
  FaYoutube,
  FaFacebook,
  FaInstagram,
  FaSquareThreads,
} from "react-icons/fa";

import { trackDownload, trackSocial} from "../analytics/tracking";

const SOCIAL_ICONS = [
  { icon: IMAGES.iconTiktok, href: LINKS.social.tiktok, network: "tiktok" },
  { icon: IMAGES.iconYoutube, href: LINKS.social.youtube, network: "youtube" },
  { icon: IMAGES.iconFacebook, href: LINKS.social.facebook, network: "facebook" },
  { icon: IMAGES.iconInstagram, href: LINKS.social.instagram, network: "instagram" },
  { icon: IMAGES.iconThreads, href: LINKS.social.threads, network: "threads" },
];

function StoreQR({ value, alt }) {
  return (
    <div className="w-32 h-32 mb-2 bg-white rounded p-1 flex items-center justify-center">
      {value ? (
        <QRCodeSVG value={value} size={120} level="M" aria-label={alt} />
      ) : (
        <div
          className="w-10 h-10 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin"
          role="status"
          aria-label="Đang tải QR"
        />
      )}
    </div>
  );
}

export default function Footer() {
  const { links: storeLinks } = useStoreLinks();

  const handleDownloadClick = (platform) => {
    trackDownload(platform, 'store');
  };

  const handleSocialClick = (network) => {
    trackSocial(network);
  }

  return (
    <footer
      className="bg-blue-600 text-white pt-10 text-sm"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      {/* ───── LOGO ───── */}
      <div className="flex justify-center mb-6 p-4">
        <img src={IMAGES.logo} alt="logo" className="h-16 w-auto" />
      </div>

      {/* ───── GIỚI THIỆU ───── */}
      <div className="mx-auto text-center px-4 mb-10">
        <p className="leading-relaxed opacity-90 text-justify">
          {CONTENT.footer.description}
        </p>
      </div>

      {/* ───── DOWNLOAD APP ───── */}
      <div className="flex justify-center mb-12">
        <div className="grid grid-cols-2 gap-10">
          {/* ANDROID */}
          <div className="flex flex-col items-center">
            <StoreQR value={storeLinks.android} alt="Android QR" />
            <a
              href={storeLinks.android || LINKS.android.store}
              target="_blank"
              rel="noreferrer"
              className="hover:opacity-80 transition-opacity"
              onClick={() => handleDownloadClick("android")}
            >
              <img src={IMAGES.googlePlay} className="h-12 w-auto" alt="Google Play" />
            </a>
          </div>

          {/* IOS */}
          <div className="flex flex-col items-center">
            <StoreQR value={storeLinks.ios} alt="iOS QR" />
            <a
              href={storeLinks.ios || LINKS.ios.store}
              target="_blank"
              rel="noreferrer"
              className="hover:opacity-80 transition-opacity"
              onClick={() => handleDownloadClick("ios")}
            >
              <img src={IMAGES.appStore} className="h-12 w-auto" alt="App Store" />
            </a>
          </div>
        </div>
      </div>

      {/* ───── CONTACT ───── */}
      <div className="flex items-center justify-center gap-4 mb-10">
        <p className="leading-relaxed opacity-90 text-justify">
          Kết nối với COLASCORE
        </p>
        <div className="flex gap-3 md:text-lg">
          {SOCIAL_ICONS.map((item, i) => (
            <a
              key={i}
              href={item.href}
              target="_blank"
              rel="noreferrer"
              onClick={() => handleSocialClick(item.network)}
            >
              <img
                src={item.icon}
                alt={item.network}
                className="w-6 h-6 object-contain"
              />
            </a>
          ))}
        </div>
      </div>

      {/* ───── COPYRIGHT ───── */}
      <div className="border-t border-white/20 text-center py-4 text-sm opacity-80">
        © {new Date().getFullYear()} {CONTENT.footer.copyright}
      </div>
    </footer>
  );
}